import BaseProxy from './Proxy';

export default class SubstoreOrderSelectionProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/order/selection', parameters);
  }
}
